//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import util from '@/lib/util';

export default {
    name: 'orders-cell',
    components: {},
    data() {
        return {
            downloadUrl: util.ApiUrl + '/file/download/',
            shop: {}
        };
    },
    methods: {
        getShop(id) {
            const shopCache = localStorage.getItem('shop');
            if (shopCache) {
                this.shop = JSON.parse(shopCache);
                return;
            }

            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + id)
                .then(res => {
                    this.shop = {};
                    this.shop = res.data.result;
                });
        },
        clickPayBtn() {
            if (this.item.id === 0) {
                return;
            }
            this.$router.push({
                name: 'pay',
                params: {
                    id: this.item.id
                }
            });
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    created() {
        // this.getShop(this.item.shopId);
    }
};
